import {submitCodeForCodeAction} from "../points/submitCodeForCodeAction";
import {validateEmpty} from "../utils/validateEmpty";
import {getCommunityType} from "../utils/getCommunityType";
import {appendToBody} from "../utils/appendToBody";
import {isMobile} from "../utils/isMobile";

export function initShare() {
    document.addEventListener("click", function (e) {
        if (e.target.closest(".js-share")) {
            e.preventDefault();

            let shareButton = e.target.closest(".js-share");
            let container = shareButton.closest(".js-timeline-entry");
            let communityType = getCommunityType(container);
            let id = container?.id;

            if (id !== undefined) {
                fetchShareElementsAndOpenModal(id, communityType);
            }
        }
    });
    function fetchShareElementsAndOpenModal(id, tmpCommunityType) {
        let modalId = 'share_modal_' + tmpCommunityType + '_' + id;
        let modalElement = document.getElementById(modalId);
        if (modalElement) {
            $(modalElement).modal("show");
        } else {
            $.ajax({
                type: "POST",
                url: "/module/community/ajax.php?action=get_share_modal",
                datatype: "json",
                data: {
                    "ajax_call_id": id,
                    "ajax_call_community_type": tmpCommunityType,
                    "ajax_call_community_type_list": communityType
                },
                success: function (output) {
                    var data = $.parseJSON(output);
                    document.querySelectorAll('.js-share-email-modal, .js-share-modal').forEach(el => el.remove());
                    if (isMobile() && navigator.share) {
                        navigator.share({
                            title: data?.entry?.description,
                            url:  data?.entry?.link,
                        })
                            .then(() => console.log("Shared successfully"))
                            .catch(err => console.error("Share failed", err));
                    } else {
                        if (!document.getElementById(modalId)) {
                            appendToBody(data.modal);
                            let modalElement = document.getElementById(modalId);
                            $(modalElement).modal("show");
                        }
                    }

                }
            });
        }
    }
    document.addEventListener('submit', function (event) {
        // Check if the submitted form matches your class
        if (event.target.matches('form.js-share-email-form')) {
            event.preventDefault(); // stop normal submission if you want custom handling


            // Example: get form data
            const formData = new FormData(event.target);
            for (const [name, value] of formData) {
                console.log(name, value);
            }
        }
    });
    $(document).on("keypress","input", function(e) {
        if(e.which == 13) {
            var target = $(e.target);
            if (target.hasClass("code_action_input")) {
                submitCodeForCodeAction(target);
            } else if (target.is("input") && target.closest("share_modal_mail") !== undefined) {
                var modal = $(this).closest(".share_modal_mail");
                if (modal.attr("id") !== undefined) {
                    var postId = modal.attr("id").split("_")[3];
                    var senderName = modal.find("input[name=input_sender_name]").val();
                    var recipientName = modal.find("input[name=input_recipient_name]").val();
                    var recipientEmail = modal.find("input[name=input_recipient_email]").val();
                    if (validateEmpty([postId, senderName, recipientName, recipientEmail])) {
                        sendShareEmail(postId, senderName, recipientName, recipientEmail);
                        $(".modal").modal("hide");
                    } else {
                        modal.find(".error_empty_fields").removeClass("hidden");
                    }
                }
            }
        }
    });
    $(document).on("click", ".share_popup", function (e) {
        e.preventDefault();
        var t = $(this).data("target"), r = "_blank", i = "600", n = "460", a = "width=" + i + ",height=" + n;
        window.open(t, r, a)
    });
    $(document).on("click", ".send_share_email", function (e) {
        var modal = $(this).closest(".share_modal_mail");
        var postId = modal.attr("id").split("_")[3];
        var tmpCommunityType = modal.attr("data-type");
        var senderName = modal.find("input[name=input_sender_name]").val();
        var recipientName = modal.find("input[name=input_recipient_name]").val();
        var recipientEmail = modal.find("input[name=input_recipient_email]").val();
        if (validateEmpty([postId, senderName, recipientName, recipientEmail])) {
            sendShareEmail(postId, senderName, recipientName, recipientEmail, mainLanguageId, tmpCommunityType);
            $(".modal").modal("hide");
        } else {
            modal.find(".error_empty_fields").removeClass("hidden");
        }
    });
}


function sendShareEmail(postId, senderName, recipientName, recipientEmail, languageID, tmpCommunityType) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=send_share_email",
        datatype: "json",
        data: {
            "ajax_call_post_id": postId,
            "ajax_call_sender_name": senderName,
            "ajax_call_recipient_name": recipientName,
            "ajax_call_recipient_email": recipientEmail,
            "ajax_call_sender_email": senderEmail,
            "ajax_call_language_id": languageID,
            "ajax_call_community_type": tmpCommunityType,
            "ajax_call_site_code": siteCode,
            "ajax_call_list_community_type": communityType
        },
        success: function (output) {
            var data = $.parseJSON(output);
            var shareModal = $('#share_modal_mail_' + data.id);
            shareModal.find("input[name=input_sender_name]").val("");
            shareModal.find("input[name=input_recipient_name]").val("");
            shareModal.find("input[name=input_recipient_email]").val("");
            shareModal.find(".error_empty_fields").addClass("hidden");

            $("body").append(data.success_modal);
            $('#success_modal_' + data.id).modal("show");
        }
    });
}